<template>
  <div class="dashboard__components">
    <Profile v-if="selection === 'Profile'" :isLoading="isLoading" />
    <Learning v-if="selection === 'Learning'" :isLoading="isLoading" />
    <PassAnalytics v-if="selection === 'Analytics'" :isLoading="isLoading" />
    <Subscriptions
      v-if="selection === 'Subscriptions'"
      :isLoading="isLoading"
      @is-managing-payment="$emit('is-managing-payment')"
    />
    <Certifications
      v-if="selection === 'Certifications'"
      :isLoading="isLoading"
    />
    <div v-if="isLoading" class="dashboard__loader-wrapper">
      <ActionLoader loaderClass="dashboard__loader" />
    </div>
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'
import Profile from '@/components/user-dashboard/Profile.vue'
import Learning from '@/components/user-dashboard/Learning.vue'
import PassAnalytics from '@/components/user-dashboard/PassAnalytics.vue'
import Subscriptions from '@/components/user-dashboard/Subscriptions.vue'
import Certifications from '@/components/user-dashboard/Certifications.vue'

export default {
  name: 'Components',
  components: {
    Profile,
    Learning,
    PassAnalytics,
    Subscriptions,
    Certifications,
    ActionLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    selection: {
      type: String,
      required: true,
    },
  },
}
</script>
